import { Tooltip } from "../components/Tooltip";
import { cn } from "../lib/utils";
import React from "react";
export const TruncatedText = ({ children, className, lineClamp = 2, mountPortal, mountPortalContainer, ...props }) => {
    const [isTruncated, setIsTruncated] = React.useState(false);
    const textRef = React.useRef(null);
    // Check if content is actually truncated by comparing scroll height to
    // client height
    // This ensures we only show the tooltip when text is cut off by line-clamp-
    React.useLayoutEffect(() => {
        const element = textRef.current;
        if (element) {
            const isOverflowing = element.scrollHeight > element.clientHeight;
            setIsTruncated(isOverflowing);
        }
    });
    const textElement = (React.createElement("div", { ref: textRef, className: cn(`line-clamp-${lineClamp} cursor-pointer select-none`, className), ...props }, children));
    if (isTruncated) {
        return (React.createElement(Tooltip, { trigger: textElement, label: children, tooltipTriggerAsChild: true, mountPortal: mountPortal, mountPortalContainer: mountPortalContainer }));
    }
    return textElement;
};
//# sourceMappingURL=TruncatedText.js.map